import { useEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import { CircularProgress } from '@mui/material';
import { signOut, onAuthStateChanged } from 'firebase/auth';
import { auth } from '../../config/firebase';
import ValidateUser from '../../components/ValidateSession';
import Chat from '../../components/Chat';
import { ref as databaseRef, onChildChanged } from 'firebase/database';
import { db } from '../../config/firebase';
import { top, getCollectionsComplete, registrarEntrada, registrarSalida } from '../../assets/js/functions';
import titulo from '../../assets/images/image_header_boticario.png';
import logo from '../../assets/images/logo-boticario.png';
import './styles.scss';

export default function Streaming() {
  const [loading, setLoading] = useState(true);
  const [streamingActivo, setStreamingActivo] = useState(false);
  const [activarIframe, setActivarIframe] = useState(false);
  const [videoUrl, setVideoUrl] = useState('');
  const [idIframe, setIdIframe] = useState('');
  const [chatId, setChatId] = useState('dia1');
  const [mensajeCerrado, setMensajeCerrado] = useState('El evento estará disponible pronto.');
  const [esDev, setEsDev] = useState(false);

  useEffect(() => {
    top();
    cargarDatos();

    const dbRef = databaseRef(db, 'dev');
    onChildChanged(dbRef, () => cargarDatos());
  }, []);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const userData = await getCollectionsComplete(`usuarios/${user.uid}`);
        setEsDev(userData?.rol === 'dev');
        registrarEntrada();
      }
    });
    return () => unsub();
  }, []);

  useEffect(() => {
    const handleSalida = () => registrarSalida();
    window.addEventListener('beforeunload', handleSalida);
    return () => window.removeEventListener('beforeunload', handleSalida);
  }, []);

  const cargarDatos = async () => {
    const [activo, server, v1, v2, v3, v4, iframe, idIframeData, chatid, numMsj, msj1, msj2, msj3] = await Promise.all([
      getCollectionsComplete('dev/streamingActivo'),
      getCollectionsComplete('dev/streamingServer'),
      getCollectionsComplete('dev/video1'),
      getCollectionsComplete('dev/video2'),
      getCollectionsComplete('dev/video3'),
      getCollectionsComplete('dev/video4'),
      getCollectionsComplete('dev/activarIframe'),
      getCollectionsComplete('dev/idIframe'),
      getCollectionsComplete('dev/chatid'),
      getCollectionsComplete('dev/numMensajeEventoCerrado'),
      getCollectionsComplete('dev/mensajeEventoCerrado1'),
      getCollectionsComplete('dev/mensajeEventoCerrado2'),
      getCollectionsComplete('dev/mensajeEventoCerrado3'),
    ]);

    const videos = { 1: v1, 2: v2, 3: v3, 4: v4 };
    const url = videos[server] || v1 || '';

    setStreamingActivo(activo);
    setActivarIframe(iframe);
    setVideoUrl(url);
    setIdIframe(idIframeData || '');
    setChatId(chatid || 'dia1');

    const mensajes = { 1: msj1, 2: msj2, 3: msj3 };
    if (mensajes[numMsj]) setMensajeCerrado(mensajes[numMsj]);

    setLoading(false);
  };

  const cerrarSesion = async () => {
    await registrarSalida();
    await signOut(auth);
    sessionStorage.clear();
    window.location.replace('/');
  };

  return (
    <ValidateUser>
      <div className='streaming'>

        <div className='streaming-topbar'>
          <div className='streaming-topbar-acciones'>
            {esDev && (
              <button className='btn-dev' onClick={() => window.location.replace('/admin/dev')}>
                Panel Dev
              </button>
            )}
            <button className='btn-logout' onClick={cerrarSesion}>
              Cerrar sesión
            </button>
          </div>
        </div>

        {loading ? (
          <div className='infoLoading'>
            <CircularProgress />
          </div>
        ) : streamingActivo ? (
          <div className='seccionVideo'>
            <div className='header-streaming'>
              <img src={titulo} alt='logo' className='titulo-streaming' />
              <img src={logo} alt='logo' className='logo-streaming' />
            </div>
            <div className='video-chat-layout'>
              <div className='video-col'>
                {activarIframe ? (
                  <iframe
                    id={idIframe}
                    src={videoUrl}
                    width='100%'
                    height='100%'
                    frameBorder='0'
                    allow='autoplay; fullscreen; picture-in-picture;'
                    title='streaming'
                    style={{ display: 'block' }}
                  />
                ) : (
                  <ReactPlayer url={videoUrl} controls={true} width='100%' height='100%' playing={true} />
                )}
              </div>
              <div className='chat-col'>
                <Chat idConferencia={chatId} />
              </div>
            </div>
          </div>
        ) : (
          <div className='texto'>
            <p>{mensajeCerrado}</p>
          </div>
        )}
      </div>
    </ValidateUser>
  );
}
